// Central API hosts — keep network config out of components.

export const API = {
  fakeStore: "https://fakestoreapi.com",
  jsonPlaceholder: "https://jsonplaceholder.typicode.com",
};

export const STORAGE_KEYS = {
  darkMode: "da-control.darkMode",
};
